import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Box, Button, Typography } from "@mui/material";

import {
  ButtonAuthorizedWrapper,
  DivAuthorizedWrapper,
  ImageBanner,
  Wrapper,
} from "src/components";
import { ContentContainer, PageHeader } from "src/components/Layouts/AppShell";

import { RENT_IMAGES } from "src/shared/assets/images";
import tokens from "src/shared/theme/tokens";

export const RentReportingConfirmationScreenContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Wrapper isAuthorizedWrapper idSelector={"wrapperContainer"}>
        <ContentContainer size="narrow">
          <PageHeader title={"Rent Reporting"} />
          <DivAuthorizedWrapper>
            <Box sx={{ width: "100%", marginBottom: 6 }}>
              <ImageBanner
                imgAlt=""
                imgPath={RENT_IMAGES.CONFIRMATION_BANNER}
                imgWidth="352px"
              />
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="h3"
                  color={tokens.colors.inkSecondary}
                  marginBottom={0}
                  textAlign={"center"}
                  lineHeight={"24px"}
                  fontSize={"17px"}
                >
                  {t("rentReporting.reportingConfirmation.title")}
                </Typography>
                <Typography
                  variant="h3"
                  color={tokens.colors.inkSecondary}
                  marginBottom={0}
                  textAlign={"center"}
                  lineHeight={"24px"}
                  fontSize={"17px"}
                >
                  {t("rentReporting.reportingConfirmation.title1")}
                </Typography>
              </Box>
            </Box>
            <ButtonAuthorizedWrapper>
              <Button
                variant="containedLarge"
                color="primary"
                fullWidth
                type="button"
                sx={{ overflow: "hidden" }}
                onClick={() => navigate("/rent/reporting/home")}
              >
                {t("buttonTexts.continueButton")}
              </Button>
            </ButtonAuthorizedWrapper>
          </DivAuthorizedWrapper>
        </ContentContainer>
      </Wrapper>
    </>
  );
};
